export default "__VITE_ASSET__DAr9eyvX__"